var React = require('react');

function Mastercard (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M149.3 106.7c82.5 0 149.3 66.9 149.3 149.3s-66.9 149.3-149.3 149.3S0 338.5 0 256s66.9-149.3 149.3-149.3","style":{"fillRule":"evenodd","clipRule":"evenodd","fill":"#ea001b"},"key":0}),React.createElement("path",{"d":"M362.7 106.7c-41.8 0-79.6 17.2-106.7 44.8 26.4 26.9 42.7 63.8 42.7 104.5s-16.3 77.6-42.7 104.5c27.1 27.7 64.9 44.8 106.7 44.8 82.5 0 149.3-66.9 149.3-149.3s-66.9-149.3-149.3-149.3","style":{"fill":"#ffb533"},"key":1}),React.createElement("path",{"d":"M256 151.5c-26.4 26.9-42.7 63.8-42.7 104.5s16.3 77.6 42.7 104.5c26.4-26.9 42.7-63.8 42.7-104.5s-16.3-77.6-42.7-104.5","style":{"fill":"#fb8205"},"key":2})]);
}

Mastercard.defaultProps = {"xmlSpace":"preserve","style":{"enableBackground":"new 0 0 512 512"},"viewBox":"0 0 512 512"};

module.exports = Mastercard;

Mastercard.default = Mastercard;
